import gql from 'graphql-tag'

export const PLAID_PUBLIC_TOKEN_QUERY = gql`
  query PlaidPublicToken($id: Int!) {
    paymentMethodPendingPlaidPublicToken(id: $id)
  }
`
